<template src="./EditSystem.html"/>

<script>
import NewSystem from "@/views/pages/Technology/Security/SystemsList/NewSystem/NewSystem.vue"
import mixins from "@/Mixins.js"
export default {
  mixins: [mixins],
  name: "edit-system",
  components: { NewSystem },
  mounted() {
    this.id = this.$route.params.id
    this.getSystem()
    this.getfunctionalities()
    this.getGrupos()
    setInterval(() => {
      this.scream = true
    }, 400)
  },
  data() {
    return {
      id: null,
      itemsActive: [],
      data: [],
      scream: false,
      nameIsValid: false,
      nameIsValidFunc: false,
      nameIsValidURL: false,
      functionalities: [],
      funcSelected: "",
      activePrompt4: false,
      activePrompt5: false,
      val: "",
      newFunctionalities: {
        id: null,
        name: "",
        description: "",
        url: "",
        active: true
      },
      idFunc: "",
      groups: [],
      group: [],
      idGroup: "",
      selectedFunctionalities: {
        item: [],
        active: true,
        name: "",
        url:""
      },
      modal: {
        remove: false,
        removeGroup: false,
        removeFunctionality: false,
        removeSystem: false,
        newFunctionality: false,
        group: false
      },
      removeMessage: "",
      invalidFields: {
        functionalityName: false,
        functionalityUrl: false,
        groupName: false,
      }
    }
  },
  watch: {
    'newFunctionalities.name': function(newVal) {
      this.invalidFields.functionalityName = this.testNullUndefinedEmpty(newVal)
        && this.invalidFields.functionalityName
    },
    'newFunctionalities.url': function(newVal) {
      this.invalidFields.functionalityUrl = this.testNullUndefinedEmpty(newVal)
        && this.invalidFields.functionalityUrl
    },
    'selectedFunctionalities.name': function(newVal) {
      this.invalidFields.groupName = this.testNullUndefinedEmpty(newVal)
        && this.invalidFields.groupName
    }
  },
  computed: {
    validName() {
      return this.newFunctionalities.name.length > 0 && this.newFunctionalities.url.length > 0 ? true : false
    },
    validInputFunc() {
      return this.selectedFunctionalities.name.length > 0 ? true: false
    },
    validInputGroup() {
      return this.group.name ? true : false
    },
    showBtnDelete() { 
      return this.groups.length > 0 || this.functionalities.length > 0 ? false : true
    }
  },
  methods: {
    editGroup() {
      this.invalidFields.groupName = this.testNullUndefinedEmpty(this.selectedFunctionalities.name)
      if(!this.invalidFields.groupName) {
        const params = this.selectedFunctionalities
        this.$vs.loading({
          container: this.$refs.content,
          scale: 0.5
        })
        this.axios
          .put(
            this.$store.state.filooServer +
              `access/systems/${this.id}/groups/${params.id}`,
            params,
            {
              headers: { Authorization: this.$session.get("bearer") }
            }
          )
          .then( response => {
            if (response.status === 200) {
              this.$swal({
                title: "Sucesso!",
                text: "Grupo atualizado",
                icon: "success"
              })
              this.modal.group = false
              this.getGrupos()
            }
          })
          .catch( () => {
            this.$swal({
              title: "Ocorreu um erro",
              text: "Grupo não atualizado, tente novamente ou contate um administrador.",
              icon: "error"
            })
          })
          .finally( () => {
            this.$vs.loading.close(this.$refs.content)
          })
      } 
    },
    actionDeleteGroup(id) {
      this.modal.remove = true
      this.modal.removeGroup = true
      this.idGroup = id
      this.removeMessage = "Você tem certeza que deseja excluir o grupo?"
      this.$nextTick(() => { this.focusInput() })
    },
    deleteGroup() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .delete(
          this.$store.state.filooServer +
            `access/systems/${this.id}/groups/${this.idGroup}`,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( () => {
          this.$swal({
            title: "Sucesso!",
            text: "Grupo deletado",
            icon: "success"
          })
        })
        .catch( error => {
          if(error.status == 204) {
            this.$swal({
              title: "Sucesso!",
              text: "Grupo deletado",
              icon: "success"
            })
            this.getGrupos()
          } else {
            this.$swal({
              title: "Ocorreu um erro",
              text: "Grupo não deletado, tente novamente ou contate um administrador.",
              icon: "error"
            })
          }      
        }).finally( () => {
          this.$vs.loading.close(this.$refs.content)
          this.modal.remove = false
          this.modal.removeGroup = false
        })
    },
    addGroup() {
      this.invalidFields.groupName = this.testNullUndefinedEmpty(this.selectedFunctionalities.name)
      if(!this.invalidFields.groupName) {
        this.$vs.loading({
          container: this.$refs.content,
          scale: 0.5
        })
        let params = {
          name: this.selectedFunctionalities.name,
          active: this.selectedFunctionalities.active,
          description: this.selectedFunctionalities.description,
          functionalities: this.selectedFunctionalities.functionalities
        }
        this.axios
          .post(
            this.$store.state.filooServer + `access/systems/${this.id}/groups`,
            params,
            {
              headers: { Authorization: this.$session.get("bearer") }
            }
          )
          .then( response => {
            if (response.status === 201) {
              this.$swal({
                title: "Sucesso!",
                text: "Grupo adicionado",
                icon: "success"
              })
              this.modal.group = false
              this.getGrupos()
            }
          })
          .catch( () => {
            this.$swal({
              title: "Ocorreu um erro",
              text: "Grupo não adicionado, tente novamente ou contate um administrador.",
              icon: "error"
            })
          }).finally( () => {
            this.$vs.loading.close(this.$refs.content)
          })
      }
    },
    updateFunc() {
      this.invalidFields.functionalityName = this.testNullUndefinedEmpty(this.newFunctionalities.name)
      this.invalidFields.functionalityUrl = this.testNullUndefinedEmpty(this.newFunctionalities.url)
      if(!this.invalidFields.functionalityName && !this.invalidFields.functionalityUrl) {
        const params = this.newFunctionalities
        this.$vs.loading({
          container: this.$refs.content,
          scale: 0.5
        })
        this.axios
          .put(
            this.$store.state.filooServer +
              `access/systems/${this.id}/functionalities/${params.id}`,
            params,
            {
              headers: { Authorization: this.$session.get("bearer") }
            }
          )
          .then( response => {
            if (response.status === 200) {
              this.$swal({
                title: "Sucesso!",
                text: "Funcionalidade atualizada",
                icon: "success"
              })
              this.getfunctionalities()
            }
          })
          .catch( () => {
            this.$swal({
              title: "Ocorreu um erro",
              text: "Funcionalidade não atualizada, tente novamente ou contate um administrador.",
              icon: "error"
            })
          }).finally( () => {
            this.$vs.loading.close(this.$refs.content)
            this.modal.newFunctionality = false
          })
      }
    },
    getGrupos() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .get(
          this.$store.state.filooServer + `access/systems/${this.id}/groups`,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( response => { this.groups = response.data })
        .catch( () => { this.groups = [] })
        .finally( () => { this.$vs.loading.close(this.$refs.content) })
    },
    getfunctionalities() {
      this.functionalities = []
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .get(
          this.$store.state.filooServer +
            `access/systems/${this.id}/functionalities`,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( response => { this.functionalities = response.data })
        .catch( () => { this.functionalities = [] })
        .finally( () => { this.$vs.loading.close(this.$refs.content) })
    },
    getSystem() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .get(this.$store.state.filooServer + `access/systems/${this.id}`, {
          headers: { Authorization: this.$session.get("bearer") }
        })
        .then( response => {
          if (response.status === 200) {
            this.$vs.loading.close(this.$refs.content)
            this.data = response.data
          }
        })
    },
    systemDelete() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .delete(this.$store.state.filooServer + `access/systems/${this.id}`, {
          headers: { Authorization: this.$session.get("bearer") }
        })
        .then( () => {
          this.$swal({
              title: "Sucesso!",
              text: "Sistema removido",
              icon: "success"
          })
        })
        .catch( error => {
          if(error.status == 204) {
            this.$swal({
              title: "Sucesso!",
              text: "Sistema removido",
              icon: "success"
            })
            this.$emit('save')
          } else {
            this.$swal({
              title: "Ocorreu um erro",
              text: "Sistema não removido, tente novamente ou contate um administrador.",
              icon: "error"
            })
          }
        })
        .finally( () => {
          this.$emit('cancelar')
          this.$vs.loading.close(this.$refs.content)
          this.modal.removeSystem = false
          this.modal.remove = false
        })
    },
    openConfirm() {
      this.modal.remove = true
      this.modal.removeSystem = true
      this.errorMessage = "Você tem certeza que deseja excluir o sistema?"
      this.$nextTick(() => { this.focusInput() })
    },
    openConfirmDel(func) {
      this.removeMessage = "Você tem certeza que deseja excluir a funcionalidade?"
      this.idFunc = func.id
      this.modal.remove = true
      this.modal.removeFunctionality = true
      this.$nextTick(() => { this.focusInput() })
    },
    addFunctionalities() {
      this.invalidFields.functionalityName = this.testNullUndefinedEmpty(this.newFunctionalities.name)
      this.invalidFields.functionalityUrl = this.testNullUndefinedEmpty(this.newFunctionalities.url)
      if( !this.invalidFields.functionalityName && !this.invalidFields.functionalityUrl) {
        this.$vs.loading({
          container: this.$refs.content,
          scale: 0.5
        })
        const params = this.newFunctionalities
        this.axios
          .post(
            this.$store.state.filooServer +
              `access/systems/${this.id}/functionalities`,
            params,
            {
              headers: { Authorization: this.$session.get("bearer") }
            }
          )
          .then( response => {
            if (response.status === 201) {
              this.$swal({
                title: "Sucesso!",
                text: "Funcionalidade adicionada",
                icon: "success"
              })
              this.getfunctionalities()
            }
          })
          .catch( () => {
            this.$swal({
              title: "Ocorreu um erro",
              text: "Funcionalidade não adicionada, tente novamente ou contate um administrador.",
              icon: "error"
            })
          }).finally( () => {
            this.$vs.loading.close(this.$refs.content)
            this.modal.newFunctionality = false
          })
      }
    },
    deleteFunctionalities() {
      this.axios
        .delete(
          this.$store.state.filooServer +
            `access/systems/${this.id}/functionalities/${this.idFunc}`,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( () => {
          this.$swal({
            title: "Sucesso!",
            text: "Funcionalidade removida",
            icon: "success"
          })
          this.getfunctionalities()
        })
        .catch( error => {
          if (error.status == 204) {
            this.$swal({
              title: "Sucesso!",
              text: "Funcionalidade removida",
              icon: "success"
            })
            this.getfunctionalities()
          }
        }).finally( () => {
          this.modal.remove = false
          this.modal.removeFunctionality = false
          this.$vs.loading.close(this.$refs.content)
        })
    },
    remove() {
      if(this.modal.removeGroup) this.deleteGroup()
      if(this.modal.removeFunctionality) this.deleteFunctionalities()
      if( this.modal.removeSystem) this.systemDelete()
    },
    newFunctionality() {
      this.newFunctionalities = {
        id: null,
        name: "",
        description: "",
        url: "",
        active: true
      }
      this.modal.newFunctionality = true
      this.invalidFields.functionalityName = false
      this.invalidFields.functionalityUrl = false
    },
    updateFunctionality(func) {
      this.modal.newFunctionality = true
      this.newFunctionalities = { ...func }
      this.invalidFields.functionalityName = false
      this.invalidFields.functionalityUrl = false
    },
    generateTextFunctionality() {
      return this.testNullUndefinedEmpty(this.newFunctionalities.id) ? 
        "Adicionar nova funcionalidade" :
        "Editar funcionalidade"
    },
    newGroup() {
      this.selectedFunctionalities = {
        item: [],
        active: true,
        name: ""
      }
      this.selectedFunctionalities.functionalities = []
      this.invalidFields.groupName = false
      this.modal.group = true
    },
    updateGroup(group) {
      this.itemsActive = group.functionalities
      this.selectedFunctionalities = { ...group }
      this.selectedFunctionalities.functionalities = []
      this.invalidFields.groupName = false
      this.modal.group = true
    },
    generateTextGroup() {
      return this.testNullUndefinedEmpty(this.selectedFunctionalities.id) ? 
        "Adicionar novo grupo"
        :"Editar grupo"
    },
    focusInput() {
    window.setTimeout(function ()
      {
        document.getElementById("buttonNo").focus()
      }, 0)
		},
  }
}
</script>

<style lang="scss" src="./EditSystem.scss" />